import { CardBody, CardTitle, FormGroup, FormText } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { LivePositionMarker } from "../../../live/LivePositionMarker";
import { DeviceInfo } from "../../../device/DeviceInfoContext";
import { CyLivePosition } from "./CyLivePosition";
import { InputEditable } from "../../../common/InputEditable";

interface Props {
  deviceInfo: DeviceInfo;
  setDeviceReadableName: (name: string) => void;
  setDeviceColor: (color: string) => void;
}

export function OwnDevice(props: Props) {
  const { t } = useTranslation();

  return (
    <CardBody>
      <CardTitle>
        <FontAwesomeIcon icon={faUser} /> {t("carousel.live.ownDeviceTitle")}
      </CardTitle>
      <FormGroup>
        <div>
          <InputEditable
            cyData={CyLivePosition.ChangeDeviceName}
            name={"deviceReadableName"}
            content={props.deviceInfo.deviceReadableName}
            updateContent={props.setDeviceReadableName}
            editAllowed={true}
          >
            {props.deviceInfo.deviceReadableName}
          </InputEditable>
          <InputEditable
            type="color"
            cyData={CyLivePosition.ChangeDeviceColor}
            name={"deviceColor"}
            content={props.deviceInfo.deviceColor}
            updateContent={props.setDeviceColor}
            editAllowed={true}
            style={{ height: "38px" }}
          >
            <LivePositionMarker
              color={props.deviceInfo.deviceColor}
              deviceIdentifier={props.deviceInfo.deviceIdentifier}
            />
          </InputEditable>
        </div>
        <FormText>{t("carousel.live.ownDeviceDesc")}</FormText>
      </FormGroup>
    </CardBody>
  );
}
